import { Organization } from "@boark/shared/types/organization";
import { Person } from "@boark/shared/types/person";
import {
  formatResidencyName,
  formatResidentNames,
} from "@boark/shared/utils/apartment-residency";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLocale } from "../stores/locale";
import { Tooltip } from "./tooltip";

export function ResidencyName({
  residency,
}: {
  residency: {
    customName?: string;
    owners?: { person?: Person; organization?: Organization }[];
    tenants?: { person?: Person; organization?: Organization }[];
  };
}) {
  const t = useLocale((state) => state.locale);

  if (!residency.customName) {
    return formatResidencyName(residency);
  }

  return (
    <Tooltip
      content={`${t.defaultName}: ${formatResidentNames(residency.owners ?? residency.tenants ?? [])}`}
    >
      <span className="inline-flex items-center gap-2">
        {residency.customName}
        <FontAwesomeIcon className="text-red-500" icon={faCircleExclamation} />
      </span>
    </Tooltip>
  );
}
